import type { ReactNode } from "react";

import { Card, CardDescription, CardTitle } from "../../components/ui/card";

/** Centered card used by the sign-in and password screens. */
export function AuthLayout({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <p className="mb-6 text-center text-sm font-semibold tracking-widest text-primary">POKIFOLIO</p>
        <Card>
          <CardTitle>{title}</CardTitle>
          {description !== undefined && <CardDescription>{description}</CardDescription>}
          <div className="mt-6">{children}</div>
        </Card>
      </div>
    </main>
  );
}
